var React = require('react');

function ThreeDotsOrange (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"3.334","cy":"3.334","r":"3.334","fill":"#e92f17","key":0}),React.createElement("circle",{"cx":"3.334","cy":"3.334","r":"3.334","transform":"translate(13.082)","fill":"#e92f17","key":1}),React.createElement("circle",{"cx":"3.334","cy":"3.334","r":"3.334","transform":"translate(26.164)","fill":"#e92f17","key":2})]);
}

ThreeDotsOrange.defaultProps = {"width":"32.833","height":"6.669"};

module.exports = ThreeDotsOrange;

ThreeDotsOrange.default = ThreeDotsOrange;
